package site.shadadman.pages.worklog.marketmlm

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJan42018MarketmlmMigratingToKMPpart1Page(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/marketmlm/jan42018MarketmlmMigratingToKMPpart1.md", FrontMatterElement.Builder { addScalar("title", "4jan2018MarketmlmMigratingToKMP"); }))
}

@Page("/worklog/marketmlm/jan42018-marketmlm-migrating-to-km-ppart1")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun Jan42018MarketmlmMigratingToKMPpart1Page() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("jan-4-2018-Migrating-To-KMP")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("We found the idea of Kotlin Multipalform very fascinating. currently our platform was only targeting Android and we did not have a ios application. this was a great oppertunety to target ios with minmum refactoring.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At first we knew that Kotlin multiplatform was in its early stages, many dependencies was not supported at the current time. first we must figure out whetch dep that we used is not compatable with KMP at this time.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Second, the early stages problem was also applicable for CMP. But because we used jetpack Compose and androidx , we did not find huge usecase that we needed to change in order to migrate with CMP. Two dependencies was not compatable: Ballon for showing toasts and Glide for image loading.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For cmp deps, we deside to get rid of Ballon and create a custom one using compose. for Glide we switched to camel.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For the KMP side almost all we used was compatable with KMP except our Database, we used realm and KMP was only supporting a new kind of DB called SQLDlight. Refactoring this section was not so challenging. The Dao was basiclly the same,the data models was the most different. while realm was using kotlin data class, sqldelight was using a custom yaml file.")
    }
}
